import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import EMTable from '../Tables/EMTable';
import { auxActions } from '../../actions/auxActions';

import {
  Paper,
  Modal,
  CircularProgress,
  withStyles,
} from '@material-ui/core';

import translate from '../../locales';
import { APP_CLAIMS, pageModes, styleWithCommonClasses } from '../../_constants/emparkConstants';
import TitleToolbar from '../Forms/TitleToolbar';
import CellTable from '../Tables/CellTable';
import ErrorMessage from '../ErrorMessage';
import Unauthorized from '../Unauthorized';

const __t = translate;

const styles = styleWithCommonClasses({
  errorText: {
    marginTop: '20px'
  }
});

class UsesPage extends React.Component {
  constructor(props) {
    super(props);

    this.handleSaveUses = this.handleSaveUses.bind(this);
  }

  componentDidMount() {
    this.props.changeMode(pageModes.list);
    this.props.fetchUses();
  }

  render() {
    const { uses, loading } = this.props;

    const rowsUsesTable = [
      { id: 'val', align: 'center', disablePadding: false, label: __t('value') },
    ];

    if (this.props.mode === pageModes.list)
      return (
        <div className={this.props.classes.root} style={{ height: '100vh' }}>
          <Unauthorized claim={APP_CLAIMS.MENU_AUX_V}>
            <Modal className={this.props.classes.loadingFixedCenter} open={loading}>
              <CircularProgress color="secondary" />
            </Modal>
            <Paper
              className={this.props.classes.paper}
              elevation={0}
            >
              <EMTable
                tableTitle={__t('uses')}
                dataSource={uses}
                rows={rowsUsesTable}
                onTableEdit={() => this.props.changeMode(pageModes.edit)}
              />
            </Paper>
          </Unauthorized>
        </div>
      )

    return (
      <div className={this.props.classes.root}>
        <Modal className={this.props.classes.loadingFixedCenter} open={loading}>
          <CircularProgress color="secondary" />
        </Modal>
        <Paper
          className={this.props.classes.paper}
          elevation={0}
        >
          <TitleToolbar
            title={__t('uses')}
            onSave={this.handleSaveUses}
            onCancel={() => this.props.changeMode(pageModes.list)}
          >
            <CellTable
              refReturnData={(returnData) => { this.tableSubmit = returnData }}
              values={uses.map(d => d.val.toString())}
              type="number"
            />
            <ErrorMessage
              className={this.props.classes.errorText}
              error={this.props.error}
            />
          </TitleToolbar>
        </Paper>
      </div>
    )
  }

  /* events */
  handleSaveUses() {
    const values = this.tableSubmit();

    let uses = values
      .filter(v => v != '')
      .map((v, i) => ({
        id: i,
        val: Number(v)
      }));

    if (uses.length === 0) {
      this.props.setError(__t("error_no_values"))
      return;
    }

    uses.sort((a, b) => a.val - b.val);

    this.props.sendUses(uses);
  }
}

function mapStateToProps(state) {
  return {
    uses: state.auxReducer.uses,
    loading: state.auxReducer.loading,
    mode: state.auxReducer.mode,
    error: state.auxReducer.error
  }
}

function mapDispatchToProps(dispatch) {
  return {
    changeMode: (mode) => {
      dispatch(auxActions.changeMode(mode));
    },
    fetchUses: () => {
      dispatch(auxActions.fetchUses());
    },
    sendUses: (uses) => {
      dispatch(auxActions.sendUses(uses))
    },
    setError: (error) => {
      dispatch(auxActions.setError(error))
    }
  }
}

UsesPage.propTypes = {
  uses: PropTypes.array,
  loading: PropTypes.bool,
  mode: PropTypes.string,
  error: PropTypes.string,
  changeMode: PropTypes.func,
  fetchUses: PropTypes.func,
  sendUses: PropTypes.func,
  setError: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UsesPage));